import React from 'react'
import './UsageStep.scoped.sass'

import { Button } from '@/components/Button/Button'
import { ReactComponent as ComeBackArrow } from '@/assets/icons/come-back-arrow.svg'
import sessionService from '@/app-domains/user/session/session.service'

const BoxesIntroStep = (props) => {
  const {
    // usage,
    closeModal,
    goToPreviousStep,
    continueOnboarding
  } = props

  // const personalLabels = ['Family', 'Friends', 'Hobbies', 'Shopping', 'Bills', 'Newsletters']
  // const businessLabels = ['Clients', 'Online Services', 'Providers', 'Management']
  // const bothLabels = personalLabels.concat(businessLabels)

  function setButtonFunctionality () {
    continueOnboarding()
  }

  return (
    <div className='main-container'>
      <div className='welcome-header'>
        <div className='come-back-arrow' onClick={goToPreviousStep}>
          <ComeBackArrow />
        </div>
        <span style={{ textAlign: 'center' }}>Boxes Philosophy</span>
      </div>
      <div className='info'>
        <p> The power of Boxes is maintaining a 1-to-1 relation between the services you sign up for and the email address you use.</p>
      </div>
      <div className='info'>
        <p>{`We suggest using the domain name of the service in the email address address you use: Signing up at Netfix.com, use netflix@${sessionService.getMe().me.defaultdomain}`}</p>
      </div>
      <div className='info'>
        <p>This makes it easy to remember and easy to find when you need to see messages to & from that service.</p>
      </div>
      <div className='buttons'>
        <div className='skip-button'>
          <Button content='Skip' type='secondary' click={closeModal} className='skip-button' size='regular'/>
        </div>
        <div className='quick-setup-button'>
          <Button content='Continue' click={setButtonFunctionality} className='quick-setup-button' size='regular'/>
        </div>
      </div>
    </div>
  )
}

export default BoxesIntroStep
